var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 offset-1"},[_c('div',{staticClass:"card form-body"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col m-10"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.link)}})])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }